import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { ActivatedRoute, ActivatedRouteSnapshot } from '@angular/router';
import { Store } from '@ngrx/store';
import { CookiePreferences, getCookiePreferences } from '@teamfoster/sdk/cookie-ngrx';
import { FromDictionaryPipe, LanguageService } from '@teamfoster/sdk/dictionary-ngrx';
import { map, Observable, take, tap } from 'rxjs';
import { Profile } from 'src/app/auth/models';
import { getUser } from 'src/app/auth/store';
import {
  getAllRelatedContent,
  getAllRelatedInitiatives,
  getAllRelatedStories,
  getRelatedStoriesLoaded,
  LoadRelatedInitiatives,
  LoadRelatedStories,
} from 'src/app/content/store';
import { Breadcrumb } from 'src/app/core/models';
import { Initiative } from 'src/app/initiatives/models';
import { Story } from '../../models';
import { getSelectedStory, LikeStory } from '../../store';
import { BaseContent } from 'src/app/content/models';

@Component({
  selector: 'app-story-detail',
  templateUrl: './story-detail.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class StoryDetailComponent implements OnInit {
  story$!: Observable<Story>;

  relatedInitiatives$!: Observable<Initiative[]>;
  relatedStories$!: Observable<Story[]>;
  relatedContent$!: Observable<BaseContent[]>;
  relatedStoriesLoaded$!: Observable<number>;

  user$!: Observable<Profile | undefined>;
  cookiePreferences$?: Observable<CookiePreferences | null>;
  showVoting = false;

  previewPlaceholder$!: Observable<string>;

  breadcrumbs: Breadcrumb[] = [];

  private dict = new FromDictionaryPipe(this.lang);

  constructor(private store: Store, private activatedRoute: ActivatedRoute, private lang: LanguageService) {}

  ngOnInit(): void {
    this.story$ = this.store.select(getSelectedStory);
    this.cookiePreferences$ = this.store.select(getCookiePreferences);
    this.relatedInitiatives$ = this.store.select(getAllRelatedInitiatives);
    this.relatedStories$ = this.store.select(getAllRelatedStories);
    this.relatedStoriesLoaded$ = this.store.select(getRelatedStoriesLoaded);
    this.relatedContent$ = this.store.select(getAllRelatedContent);
    this.user$ = this.store.select(getUser);
    this.previewPlaceholder$ = this.user$.pipe(
      map(a => (a?.roles.includes('Administrator') ? 'verhaal-niet-gepubliceerd-redactie' : 'verhaal-niet-gepubliceerd')),
      map(a => this.dict.transform(a))
    );

    this.story$.pipe(take(1)).subscribe(a => {
      this.breadcrumbs = [
        {
          routerLink: ['/verhalen'],
          title: this.dict.transform('breadcrumbs-verhalen-overzicht-label'),
        },
        {
          title: a.title,
        },
      ];
    });
  }

  like(id: number) {
    this.store.dispatch(LikeStory({ id }));
  }
}
